import React from 'react';
import { fontTokens, colorTokens } from '../../theme/designTokens';

type TypographyProps = {
  children: React.ReactNode;
  className?: string;
};



type TypographyVariant = keyof typeof fontTokens;



type ColorVariant = keyof typeof colorTokens;

interface TypographyComponentProps {
  fontcss: TypographyVariant;
  colorcss?: ColorVariant;
  children: React.ReactNode;
}

export const Typography: React.FC<TypographyComponentProps> = ({ fontcss, colorcss, children }) => {
  const fontClass = fontTokens[fontcss];
  const colorClass = colorcss ? colorTokens[colorcss] : '';
  return (
    <div className={`${fontClass} ${colorClass}`}>
      {children}
    </div>
  );
};